import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { CompareProvider } from "@/context/CompareContext";
import { BrokersProvider } from "@/context/BrokersContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { Layout } from "@/components/layout/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Finder from "@/pages/Finder";
import Brokers from "@/pages/Brokers";
import BrokerProfile from "@/pages/BrokerProfile";
import Compare from "@/pages/Compare";
import Swaps from "@/pages/Swaps";
import Signals from "@/pages/Signals";
import SignalDetail from "@/pages/SignalDetail";
import About from "@/pages/About";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import Offers from "@/pages/Offers";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminBrokers from "@/pages/admin/AdminBrokers";
import AdminSwaps from "@/pages/admin/AdminSwaps";
import RequireAdmin from "@/pages/admin/RequireAdmin";

function App() {
  return (
    <BrokersProvider>
      <AdminAuthProvider>
        <CompareProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route element={<RequireAdmin />}>
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Navigate to="brokers" replace />} />
                  <Route path="brokers" element={<AdminBrokers />} />
                  <Route path="swaps" element={<AdminSwaps />} />
                </Route>
              </Route>

              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/brokers" element={<Brokers />} />
                <Route path="/brokers/finder" element={<Finder />} />
                <Route path="/brokers/compare" element={<Compare />} />
                <Route path="/brokers/:slug" element={<BrokerProfile />} />
                <Route path="/swaps" element={<Swaps />} />
                <Route path="/signals" element={<Signals />} />
                <Route path="/signals/:id" element={<SignalDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/articles" element={<Articles />} />
                <Route path="/articles/:slug" element={<ArticleDetail />} />
                <Route path="/offers" element={<Offers />} />
                <Route path="/legal/:slug" element={<Legal />} />
                <Route path="/faq" element={<Legal />} />
                <Route path="/contact" element={<Legal />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors={false} toastOptions={{ className: "font-sans" }} />
        </CompareProvider>
      </AdminAuthProvider>
    </BrokersProvider>
  );
}

export default App;
